<template>
    <div>
        <el-tabs v-model="selectedTabName" type="border-card" @tab-click="setManualComponent(selectedTabName)">
            <el-tab-pane :label="$t('message.item_overview')"  name="samlOverview"></el-tab-pane>
            <el-tab-pane :label="$t('message.item_saml_setting_buddycom')"  name="samlBuddycom"></el-tab-pane>
            <el-tab-pane :label="$t('message.item_saml_setting_adfs')"  name="samlAdfs"></el-tab-pane>
            <el-tab-pane :label="$t('message.item_saml_setting_gsuite')"  name="samlGsuite"></el-tab-pane>
            <component :is="selectedManual"/>
        </el-tabs>
    </div>
</template>

<script>
import axios from 'axios';
import commonUtil from './commonutil.js';

const SAML_OVERVIEW = "samlOverview";
const SAML_BUDDYCOM = "samlBuddycom";
const SAML_ADFS = "samlAdfs";
const SAML_GSUITE = "samlGsuite";
export default {
    data () {
        return {
            selectedTabName: null,
            selectedManual: null,
        }
    },
    created: function() {
        this.selectedTabName = SAML_OVERVIEW;
        this.setManualComponent(this.selectedTabName);
    },
    methods: {
        handleTabClick() {
            this.setManualComponent(this.selectedTabName);
        },
        setManualComponent(manualName) {
            this.selectedManual = manualName + "_" + this.$i18n.locale;
        }
    },
    watch: {
    },
    components: {
        samlOverview_ja(resolve, reject) {
            axios.get("../manual/ja/" + SAML_OVERVIEW + ".html").then(response => { resolve({ template: response.data }) })
        },
        samlOverview_en(resolve, reject) {
            axios.get("../manual/en/" + SAML_OVERVIEW + ".html").then(response => { resolve({ template: response.data }) })
        },
        samlBuddycom_ja(resolve, reject) {
            axios.get("../manual/ja/" + SAML_BUDDYCOM + ".html").then(response => { resolve({ template: response.data }) })
        },
        samlBuddycom_en(resolve, reject) {
            axios.get("../manual/en/" + SAML_BUDDYCOM + ".html").then(response => { resolve({ template: response.data }) })
        },
        samlAdfs_ja(resolve, reject) {
            axios.get("../manual/ja/" + SAML_ADFS + ".html").then(response => { resolve({ template: response.data }) })
        },
        samlAdfs_en(resolve, reject) {
            axios.get("../manual/en/" + SAML_ADFS + ".html").then(response => { resolve({ template: response.data }) })
        },
        samlGsuite_ja(resolve, reject) {
            axios.get("../manual/ja/" + SAML_GSUITE + ".html").then(response => { resolve({ template: response.data }) })
        },
        samlGsuite_en(resolve, reject) {
            axios.get("../manual/en/" + SAML_GSUITE + ".html").then(response => { resolve({ template: response.data }) })
        }
    }
}
</script>

<style scoped>
.el-tabs--border-card {
    box-shadow: none !important;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
    color: #5171cb;
    opacity: 0.7;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item.is-active {
    color: #848991;
    background: #ffffff;
    border: none;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item {
    color: #5171cb;
    background: #f6f6f6;
}
.el-tabs__nav-scroll {
    background: #f6f6f6;
}
.el-tabs--border-card >>> .el-tabs__header {
    border: none;
    background: #f6f6f6;
}
.el-tabs--border-card >>> .el-tabs__content {
    padding: 0px;
}
.el-tabs--border-card {
    border: none;
}

.manual-title {
    padding: 20px;
    font-size: 14px;
    color: #848991;
}
.manual-header-record {
    background-color: #f6f6f6
}
.manual-record-item {
    padding:10px;
}
.manual-item-language {
    padding: 10px;
    width: 120px;
}
.manual-body {
    color: #848991;
    font-size: 14px;
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
}

</style>
